module.exports = [
  {
    url: '/processNode/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            process_node_id: '608617919047274493',
            name: '严管车辆预约审批-石化大队审核',
            countersign: 0,
            remark: 'process_node_备注',
            create_user_id: '100',
            create_time: '2024-03-13 19:18:27',
            update_time: '2024-03-13 19:18:27',
            deleted: 0,
          },
          {
            process_node_id: '608618199524573729',
            name: '严管车辆预约审批-石化大队确认',
            countersign: 0,
            remark: 'process_node_备注',
            create_user_id: '100',
            create_time: '2024-03-13 19:19:34',
            update_time: '2024-03-13 19:19:34',
            deleted: 0,
          },
        ],
      }
    },
  },
  {
    url: '/v2/processNode/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/v2/processNode/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/processNode/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/process/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            process_id: '608632813750584832',
            name: '普通车辆预约审批',
            type: 4,
            process_definition_id: '608629809521625984',
            create_user_id: '100',
            create_time: '2024-03-13 20:17:38',
            update_time: '2024-03-13 20:17:38',
            deleted: 0,
            create_user: {
              user_id: '100',
              user_name: '运维账户',
              account: 'yisa',
              gender: 0,
            },
            process_definition: {
              process_definition_id: '608629809521625984',
              name: '普通车辆预约审批',
              remark: '备注',
              create_user_id: '100',
              create_time: '2024-03-13 20:05:42',
              update_time: '2024-03-13 20:29:10',
              deleted: 0,
            },
          },
        ],
      }
    },
  },
  {
    url: '/process/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/process/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/process/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/processDefinition/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            process_definition_id: '608629809521625984',
            name: '普通车辆预约审批',
            remark: '',
            create_user_id: '100',
            create_time: '2024-03-13 20:05:42',
            update_time: '2024-03-13 20:05:42',
            deleted: 0,
            createUser: {
              user_id: '100',
              user_name: '运维账户',
              account: 'yisa',
              gender: 0,
              phone: '18814383363',
              depart_id: '828735811590553600',
              status: 1,
              create_user_id: '100',
              create_time: '2024-01-29 11:00:00',
              update_time: '2024-03-13 10:11:28',
              deleted: 0,
            },
            definitionNodeList: [
              {
                definition_node_id: '608629809521625983',
                process_definition_id: 608629809521625984,
                process_node_id: 608618397223092253,
                name: '普通车辆预约审批-石化大队审批',
                remark: '',
                countersign: 0,
                next_id: 0,
                start_node: 1,
              },
              {
                definition_node_id: '608629809521625983',
                process_definition_id: 608629809521625984,
                process_node_id: 608618397223092253,
                name: '2222',
                remark: '',
                countersign: 0,
                next_id: 0,
                start_node: 1,
              },
            ],
          },
        ],
      }
    },
  },
  {
    url: '/v2/processDefinition/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/processDefinition/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/processDefinition/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
]
